import services from '../services'
import * as types from './mutation-types'

// Forms
export const GetForms = ({ commit }, params) => (
  services.listForms(params).then(res => {
    commit(types.SET_FORMS, res.data)
    return res.data
  })
)

export const GetForm = async ({ commit }, id) => {
  const res = await services.getForm(id)
  commit(types.SET_FORM, res.data.data)
  return res.data.data
}

export const GetFormBuilder = async ({ commit }, id) => {
  commit(types.SET_LOADING, true)
  try {
    const res = await services.getFormBuilder(id)
    const data = res.data.data || res.data
    commit(types.SET_FORM, data)
    commit(types.SET_STEPS, data.steps || [])
    commit(types.SET_FIELDS, data.fields || [])
    commit(types.SET_LOADING, false)
    return data
  } catch (error) {
    commit(types.SET_LOADING, false)
    throw error
  }
}

export const CreateForm = async ({ commit }, payload) => {
  const res = await services.createForm(payload)
  commit(types.SET_FORM, res.data.data)
  return res.data.data
}

export const SaveFormComplete = async ({ commit, state }) => {
  const payload = {
    form: state.form,
    steps: state.steps,
    fields: state.fields
  }
  const res = await services.saveFormComplete(state.form.id, payload)
  commit(types.SET_DIRTY, false)
  return res.data
}

export const ChangeStatus = async ({ commit }, id) => {
  const res = await services.changeStatus(id)
  return res.data
}

export const DeleteForm = async ({ commit }, id) => {
  console.log('🗑️ DeleteForm action called with id:', id)
  const res = await services.deleteForm(id)
  return res.data
}

export const DuplicateForm = async ({ commit }, id) => {
  const res = await services.duplicateForm(id)
  return res.data
}

// Steps
export const AddStep = ({ commit, state }, step) => {
  const newStep = {
    ...step,
    order: state.steps.length,
    _isNew: true
  }
  commit(types.ADD_STEP, newStep)
  commit(types.SET_DIRTY, true)
  return newStep
}

export const UpdateStepLocal = ({ commit, state }, step) => {
  const index = state.steps.findIndex(s => s.id === step.id || s._tempId === step._tempId)
  if (index !== -1) {
    commit(types.UPDATE_STEP, { index, step })
    commit(types.SET_DIRTY, true)
  }
}

export const RemoveStep = ({ commit, state }, stepId) => {
  const index = state.steps.findIndex(s => s.id === stepId || s._tempId === stepId)
  if (index !== -1) {
    commit(types.REMOVE_STEP, index)
    // Remove fields from this step
    const fieldsToRemove = state.fields.filter(f => f.step_id === stepId)
    fieldsToRemove.forEach(f => {
      const fieldIndex = state.fields.findIndex(field => field.id === f.id || field._tempId === f._tempId)
      if (fieldIndex !== -1) {
        commit(types.REMOVE_FIELD, fieldIndex)
      }
    })
    commit(types.SET_DIRTY, true)
  }
}

export const ReorderSteps = ({ commit, state }, steps) => {
  const reordered = steps.map((step, index) => ({
    ...step,
    order: index
  }))
  commit(types.SET_STEPS, reordered)
  commit(types.SET_DIRTY, true)
}

// Fields
export const AddField = ({ commit, state }, field) => {
  const newField = {
    ...field,
    order: state.fields.filter(f => f.step_id === field.step_id).length,
    _isNew: true,
    _tempId: `temp_${Date.now()}`
  }
  commit(types.ADD_FIELD, newField)
  commit(types.SET_DIRTY, true)
  return newField
}

export const UpdateFieldLocal = ({ commit, state }, field) => {
  const index = state.fields.findIndex(f => f.id === field.id || f._tempId === field._tempId)
  if (index !== -1) {
    commit(types.UPDATE_FIELD, { index, field })
    commit(types.SET_DIRTY, true)
  }
}

export const RemoveField = ({ commit, state }, fieldId) => {
  const index = state.fields.findIndex(f => f.id === fieldId || f._tempId === fieldId)
  if (index !== -1) {
    commit(types.REMOVE_FIELD, index)
    commit(types.SET_DIRTY, true)
  }
}

export const ReorderFields = ({ commit, state }, { stepId, fields }) => {
  const otherFields = state.fields.filter(f => f.step_id !== stepId)
  const reorderedFields = fields.map((field, index) => ({
    ...field,
    order: index
  }))
  commit(types.SET_FIELDS, [...otherFields, ...reorderedFields])
  commit(types.SET_DIRTY, true)
}

export const DuplicateFieldLocal = ({ commit, state }, fieldId) => {
  const field = state.fields.find(f => f.id === fieldId || f._tempId === fieldId)
  if (field) {
    const newField = {
      ...field,
      id: null,
      _tempId: `temp_${Date.now()}`,
      _isNew: true,
      name: `${field.name}_copy`,
      label: `${field.label} (Cópia)`,
      order: state.fields.filter(f => f.step_id === field.step_id).length
    }
    commit(types.ADD_FIELD, newField)
    commit(types.SET_DIRTY, true)
    return newField
  }
}

// Field Types
export const GetFieldTypes = async ({ commit }) => {
  const res = await services.getFieldTypes()
  commit(types.SET_FIELD_TYPES, res.data.data || res.data)
  return res.data
}

export const GetFieldTypesGrouped = async ({ commit }) => {
  const res = await services.getFieldTypesGrouped()
  commit(types.SET_FIELD_TYPES_GROUPED, res.data.data || res.data)
  return res.data
}

// Standard Fields - Auto inicialização (apenas name e email como fixos)
export const InitializeStandardFields = async ({ commit, state }) => {
  let fieldTypes = []

  // Se já tem fieldTypesGrouped no state, usar ele
  if (state.fieldTypesGrouped && Object.keys(state.fieldTypesGrouped).length > 0) {
    Object.values(state.fieldTypesGrouped).forEach(group => {
      if (Array.isArray(group)) {
        fieldTypes = [...fieldTypes, ...group]
      }
    })
  }

  // Filtrar apenas os standard
  let standardFieldTypes = fieldTypes.filter(ft => ft.is_standard === true)

  if (standardFieldTypes.length === 0) {
    const res = await services.getFieldTypes({ is_standard: true })
    const allTypes = res.data.data || res.data
    standardFieldTypes = allTypes.filter(ft => ft.is_standard === true)
  }

  // Apenas name e email são adicionados automaticamente como campos fixos
  const autoAddFields = ['name', 'email']
  standardFieldTypes = standardFieldTypes.filter(ft => autoAddFields.includes(ft.name))

  // Ordenar: name primeiro, email depois
  standardFieldTypes.sort((a, b) => {
    return autoAddFields.indexOf(a.name) - autoAddFields.indexOf(b.name)
  })

  // Configurações dos campos auto-adicionados
  const fieldConfigs = {
    name: {
      required: true,
      is_visible: true,
      disabled: true,
      placeholder: 'Digite seu nome completo',
      layout: { cols: 12 }
    },
    email: {
      required: true,
      is_visible: true,
      disabled: true,
      placeholder: 'seu@email.com',
      layout: { cols: 6 }
    }
  }

  // Adicionar os campos ao state
  standardFieldTypes.forEach((fieldType, index) => {
    const config = fieldConfigs[fieldType.name] || {}

    const newField = {
      field_type_id: fieldType.id,
      name: fieldType.name,
      label: fieldType.label,
      placeholder: config.placeholder || '',
      help_text: null,
      default_value: null,
      options: fieldType.default_config?.options || null,
      validations: fieldType.default_validations || {},
      conditions: null,
      config: fieldType.default_config || {},
      layout: config.layout,
      order: index,
      required: config.required,
      unique: fieldType.name === 'email',
      disabled: config.disabled,
      readonly: false,
      is_visible: config.is_visible,
      status: true,
      step_id: null,
      _isNew: true,
      _tempId: `standard_${fieldType.name}_${Date.now()}`,
      _isStandard: true,
      field_type: fieldType
    }

    commit(types.ADD_FIELD, newField)
  })

  return standardFieldTypes.length
}

// Selection
export const SelectField = ({ commit }, field) => {
  commit(types.SET_SELECTED_FIELD, field)
}

export const SelectStep = ({ commit }, step) => {
  commit(types.SET_SELECTED_STEP, step)
}

export const ClearSelection = ({ commit }) => {
  commit(types.SET_SELECTED_FIELD, null)
  commit(types.SET_SELECTED_STEP, null)
}

// Reset
export const ResetBuilder = ({ commit }) => {
  commit(types.RESET_BUILDER)
}

export const SetDirty = ({ commit }, value) => {
  commit(types.SET_DIRTY, value)
}
